import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Notification {
  title: string;
  message: string;
  id: string;
  createdAt: number;
  read: boolean;
}

export interface NotificationStateProps {
  notifications: Notification[];
}

const initialState: NotificationStateProps = {
  notifications: [],
};

export const StopPointSlice = createSlice({
  name: "notification",
  initialState: initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      const existis = state.notifications.some(
        (n) => n.id === action.payload.id
      );
      if (!existis) {
        state.notifications.push(action.payload);
      }
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (n) => n.id !== action.payload
      );
    },
    markAsRead: (state, action) => {
      const notification = state.notifications.find(
        (n) => n.id === action.payload
      );
      if (notification) {
        notification.read = true;
      }
    },
  },
});

export const NotificationActions = StopPointSlice.actions;

export default StopPointSlice.reducer;
